<template>
  <div class="samaple__conntents">
    <div style="margin-top: 20px;">
      <div class="midashi">
        <div>無料予想サイトの</div>
        <div>無料予想ランキング</div>
      </div>
    </div>
    <div style="margin-top: 20px;">
  <!--    <div style="width: 50%; margin-left: 23%;"> -->
      <div style="width: 100%;">
        <h2>2021年1月</h2>
        <vue-good-table :columns="columns" :rows="rows202101" />
        <br>
        <br>
        <br>
        <h2>2020年12月</h2>
        <vue-good-table :columns="columns" :rows="rows202012" />
        <br>
        <br>
        <br>
        <h2>2020年11月</h2>
        <vue-good-table :columns="columns" :rows="rows202011" />
        <br>
        <br>
        <br>
        <h2>2020年10月</h2>
        <vue-good-table :columns="columns" :rows="rows202010" />
      </div>
      <br>
      <br>
      <br>
      <!--
      <router-link to="{ name: 'foo'}">Go to Foo</router-link>
      -->
      <div class="my_rule_message">こちらの検証方法ですが、以下のマイルールに基づいて算出していますのでご理解の上よろしくお願いいたします。</div>
      <div class="my_rule_message">1、推奨の1点の金額があるサイトは最低額を採用しています。</div>
      <div class="my_rule_message">2、推奨の1点の金額がない場合は、10点までなら500円、10点以上は300円。もし、300円で購入しても10000円を超える場合は10000円に収まるように調整しています。</div>
      <div class="my_rule_message">3、予想レース数が多いサイトは、重賞のみとしています。(独断ですみません。現状1サイトが該当します)</div>
      <div class="my_rule_message">4、あまりにも収支結果がマイナスの場合は検証対象サイトから外して、その代わり新たなサイトを検証対象に入れます。10サイトを下回ることはないかと(独断ですみません)</div>
      <div class="my_rule_message">5、本命馬券と穴馬券など2パターン用意している場合は、傾向をみて回収率が高い方を採用します。(独断ですみません。現状1サイトが該当します)</div>
      <div class="my_rule_message">6、手動で収集、検証をしているため万が一誤記等があるかもしれませんが、一切の責任は負いませんのでご理解ください(捏造とか詐欺の意図は全くなです、ミスがないように細心の注意を払ってやっていますが、ミスったらごめんなさいm(_ _)m)</div>
      <div class="my_rule_message">7、たまに寝坊などして、朝公開の予想の閲覧し忘れがあります。。この点もご了承いただければ。。。これも当然、捏造等の意図はないです。むしろ予想サイト運営者の方々が「せっかく当たっているのに見逃しやがって！！」とお怒りになるパターンですね。。もしそのような場合は大変申し訳ありません。</div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import vueGoodTable from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
 
Vue.use(vueGoodTable)
export default {
  data() {
    return {
      columns: [
        {
          label: 'ランク',
          field: 'rank',
          width: '15%'
        },
        {
          label: 'サイト名',
          field: 'siteName',
          width: '25%'
        },
        {
          label: '戦歴',
          field: 'history',
          width: '15%'
        },
        {
          label: '馬券代(円)',
          field: 'bakenPrice',
          type: 'number',
          width: '15%'
        },
        /*
        {
          label: '回収額',
          field: 'float',
          type: 'number'
        },
        */
        {
          label: '払戻額(円)',
          field: 'resultPrice',
          type: 'number',
          width: '15%'
        },
        {
          label: '回収率(%)',
          field: 'resultRate',
          width: '15%'
        },
      ],
      rows202010: [
        { id: 1, rank:'1位', siteName: 'ダービーレコード', history: '7戦2勝', bakenPrice: '72000',resultPrice:'198100', resultRate:'' },
        { id: 2, rank:'2位', siteName: 'EXTRA', history: '9戦2勝', bakenPrice: '47800',resultPrice:'81120', resultRate:'' },
        { id: 3, rank:'3位', siteName: 'TURFVISION', history: '17戦6勝', bakenPrice: '46900',resultPrice:'72840', resultRate:'' },
      ],
      rows202011: [
        { id: 1, rank:'1位', siteName: '栗東会議', history: '10戦8勝', bakenPrice: '45000',resultPrice:'98790', resultRate:'' },
        { id: 2, rank:'2位', siteName: 'うまっぷ', history: '9戦4勝', bakenPrice: '41000',resultPrice:'47600', resultRate:'' },
        { id: 3, rank:'3位', siteName: 'GALLOP JAPAN', history: '10戦5勝', bakenPrice: '72700',resultPrice:'77910', resultRate:'' },
      ],
      rows202012: [
        { id: 1, rank:'1位', siteName: '競馬学会', history: '9戦2勝', bakenPrice: '39000',resultPrice:'64450', resultRate:'' },
        { id: 2, rank:'2位', siteName: 'うまっぷ', history: '8戦5勝', bakenPrice: '38000',resultPrice:'53000', resultRate:'' },
        { id: 3, rank:'3位', siteName: '的中マーケット', history: '9戦3勝', bakenPrice: '146000',resultPrice:'170840', resultRate:'' },
      ],
      rows202101: [
        { id: 1, rank:'1位', siteName: 'TURFVISION', history: '10戦8勝', bakenPrice: '45900',resultPrice:'66900', resultRate:'' },
        { id: 2, rank:'2位', siteName: '栗東会議', history: '10戦5勝', bakenPrice: '45000',resultPrice:'57840', resultRate:'' },
        { id: 3, rank:'3位', siteName: 'ホライズン', history: '20戦7勝', bakenPrice: '98200',resultPrice:'123640', resultRate:'' },
      ]
    }
  },
  methods: {
    calcResultRate(rowObj,index) {
      let bp =rowObj[index].bakenPrice
      let rp =rowObj[index].resultPrice
      let rate = ((rp / bp) * 100 / 100 ) * 100
      return Math.round(rate)
    }
  },
  mounted:function() {
    this.rows202010[0].resultRate = this.calcResultRate(this.rows202010,0)
    this.rows202010[1].resultRate = this.calcResultRate(this.rows202010,1)
    this.rows202010[2].resultRate = this.calcResultRate(this.rows202010,2)
    this.rows202011[0].resultRate = this.calcResultRate(this.rows202011,0)
    this.rows202011[1].resultRate = this.calcResultRate(this.rows202011,1)
    this.rows202011[2].resultRate = this.calcResultRate(this.rows202011,2)
    this.rows202012[0].resultRate = this.calcResultRate(this.rows202012,0)
    this.rows202012[1].resultRate = this.calcResultRate(this.rows202012,1)
    this.rows202012[2].resultRate = this.calcResultRate(this.rows202012,2)
    this.rows202101[0].resultRate = this.calcResultRate(this.rows202101,0)
    this.rows202101[1].resultRate = this.calcResultRate(this.rows202101,1)
    this.rows202101[2].resultRate = this.calcResultRate(this.rows202101,2)
  }
}
</script>
<style>
.samaple__conntents {
  margin: 0 auto;
  min-height: 100vh;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.my_rule_message {
  color:blue;
  margin: 0 auto;
  font-size: 16px;
  text-align: left;
}

.midashi {
  font-size: 32px;
  color: #364e96;/*文字色*/
  padding: 0.5em 0;/*上下の余白*/
  border-top: solid 3px #364e96;/*上線*/
  border-bottom: solid 3px #364e96;/*下線*/
}
</style>